<template>
    <div
        class="qrcodeBox"
        v-if="!showInputMobile"
        >
        <div v-if="qrcodeUrl">
            <img
                class="loginCode"
                :src="qrcodeUrl"
                alt=""
                />
            <div class="tip">打开微信扫码关注公众号注册/登录</div>
        </div>
        <div
            class="mark"
            v-if="isExprice"
            >
            <p class="tip">二维码已失效,请刷新后在登录</p>
            <el-button type="primary" @click="getQRCode()">刷新二维码</el-button>
        </div>
    </div>
    <MobileLogin
        v-else
        :openID="openID"
        text="绑定手机号"
        @submitHandler="submitHandler"
        />
</template>

<script>

import MobileLogin from './mobile-login.vue'

export default {
    components: {
        MobileLogin
    },
    data() {
        return {
            baseUrl: 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=',
            ticket: '',
            qrcodeUrl: '',
            isExprice: false,
            timer: null,
            qrcodeTimer: null,
            showInputMobile: false,
            openID: ''
        }
    },
    methods: {
        refreshCode() {

        },

        // 心跳检测扫码结果
        checkScanResult() {
            if(this.timer == null) {
                this.timer = setInterval(() => {
                    this.checkCode()
                }, 2000)
            }
        },

        // 检测是否扫码
        checkCode() {
            this.$ajax({
                type: 'get',
                url: `${this.$store.state.api.baseWebUrl}/wechat/openID`,
                data: {
                    ticket: this.ticket
                },
                callback: data => {
                    if(data.openID){
                        clearInterval(this.timer)
                        clearTimeout(this.qrcodeTimer)
                        this.getToken(data)
                    }
                },
            });
        },

        // 获取token
        getToken(data) {
            this.openID = data.openID
            // 判断用户是否注册过
            if(data.isExist == '0') {
                this.showInputMobile = true
                showMsg("请绑定手机号！")
            }else{
                this.$emit('submitHandler', {
                    wechatId: data.openID
                })
            }
        },

        // 二维码过期
        qrcodeExprice() {
            if(this.qrcodeTimer == null){
                this.qrcodeTimer = setTimeout(() => {
                    this.isExprice = true
                    clearInterval(this.timer)
                    this.timer = null

                    clearTimeout(this.qrcodeTimer)
                    this.qrcodeTimer = null
                },1000*60*10)
            }
        },

        // 获取二维码
        getQRCode() {
            this.$ajax({
                type: 'get',
                url: `${this.$store.state.api.baseWebUrl}/wechat/ticket`,
                callback: data => {
                    this.qrcodeUrl = this.baseUrl + data.ticket
                    this.ticket = data.ticket
                    this.checkScanResult()
                    this.qrcodeExprice()
                    this.isExprice = false
                }
            });
        },

        submitHandler(data) {
            this.$emit('submitHandler', data)
        }
    },
    mounted() {
        this.getQRCode()
    },

    destroyed() {
        if(this.timer != null){
            clearInterval(this.timer)
        }
        if(this.qrcodeTimer != null){
            clearTimeout(this.qrcodeTimer)
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@css/var.scss';
    .qrcodeBox {
        position: relative;
        text-align: center;

        img {
            width: 360px;
            height: auto;
        }

        .mark {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            padding-top: 100px;
            background-color: hsla(0,0%,100%,.9);
            .tip {
                padding-bottom: 40px;
            }
        }
    }
</style>
